import React, { useState } from 'react';
import { TeamAPI } from '../../../services/api';

interface Team {
  id: number;
  team_id: string;
  team_name: string;
  created_at: string;
  [key: string]: any;
}

interface AwaitingConfirmationStatusProps {
  team: Team;
  onUpdate: () => void;
}

const AwaitingConfirmationStatus: React.FC<AwaitingConfirmationStatusProps> = ({ team, onUpdate }) => {
  const [loading, setLoading] = useState(false);

  const getDaysAgo = () => {
    const createdDate = new Date(team.created_at);
    const now = new Date();
    const diffTime = Math.abs(now.getTime() - createdDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const handleCancelRequest = async () => {
    setLoading(true);
    try {
      const response = await TeamAPI.cancelJoinRequest(team.team_id);
      console.log('Join request cancelled:', response);
      
      // Refresh team data to show updated status
      onUpdate();
    } catch (error) {
      console.error('Error canceling request:', error);
      alert('Failed to cancel join request. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="flex items-center space-x-2 mb-4">
        <svg className="w-5 h-5 text-gray-600" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
        </svg>
        <h3 className="text-lg font-semibold text-gray-900">Awaiting confirmation</h3>
      </div>

      <p className="text-sm text-gray-600 mb-4">
        You have requested to join {team.team_name} {getDaysAgo()} days ago.
      </p>

      <p className="text-sm text-gray-600 mb-6">
        Please contact your team mate to confirm in order to continue with 
        your application
      </p>

      <button
        onClick={handleCancelRequest}
        disabled={loading}
        className="w-full bg-gray-800 text-white py-3 px-4 rounded-lg hover:bg-gray-700 transition-colors font-medium disabled:opacity-50"
      >
        {loading ? 'Processing...' : 'Cancel request'}
      </button>
    </div>
  );
};

export default AwaitingConfirmationStatus;